var jQuery = require('jquery');
require('../web/jquery.cookie');
require('../web/jquery.unveil');

;(function($, window, document, undefined ) {
  "use strict";

  var PLUGIN_NAME = "inspirationFavorites";
  var PLUGIN_VERSION = "v1.0";

  var	DEFAULTS = {
    data: [],
    urlForPdfData: ''
  };

  /**
   * set basic variables
   * create options and settings for this instance
   * @param element - DOM Element the plugin is applied to
   * @param options - custom settings to be merged with DEFAULTS
   * @constructor
   */
  var InspirationFavorites = function ( element, options ) {
    this.element = element;
    this.$t = $(this.element);

    this.products = [];
    this.cookieName = 'CSB_inspiration_favorites';
    this.lang = window.projectConfig.lang;

    this.messages = {
      'cs' : {
        'addToFavorites' : 'Přidat do oblíbených',
        'inCart' : 'V oblíbených',
        'removeFromFavorites' : 'Odebrat z oblíbených'
      },
      'en' : {
        'addToFavorires' : 'Add To favorites',
        'inCart' : 'In favorites',
        'removeFromFavorites' : 'Remove from favorites'
      }
    };

    // merge options
    this.options = $.extend(true, {}, DEFAULTS, options );
    this._defaults = DEFAULTS;
    this.initialise();
  };

  /**
   * init function
   */
  InspirationFavorites.prototype.initialise = function() {
    var self = this;
    this.handleCookie();
    $(document).on('betonSliderLoaded', function() {
      self.checkItemPresenceInFavorites();
    });
    this.handleListenersForAddItemToFavorites();
    this.handleListenersForRemoveItemFromFavorites();
    this.handleListenersForShowFavoritesOnly();
    this.handleListenersForShowWholeContent();
    hs.Expander.prototype.onAfterExpand = function() {
      self.handleHighSlide();
    };
    hs.Expander.prototype.onAfterClose = function() {
      self.reloadContent();
    };
    this.handleListenersForPdfExport();
  };

  InspirationFavorites.prototype.handleCookie = function() {
    var self = this;

    if (!($.cookie(this.cookieName))) {
      $.cookie(this.cookieName, '', { path: '/' });
    } else {
      var cookieVal = $.cookie(this.cookieName);
    }
  };

  InspirationFavorites.prototype.handleListenersForAddItemToFavorites = function() {
    var self = this;

    $(document).on('click', '.inspirationAddToFavorites', function(e) {
      e.preventDefault();
      var id = $(this).data('motiveId');
      self.addToFavorites(id, this);
    });
  };

  InspirationFavorites.prototype.addToFavorites = function(id, element) {

    var cookieVal = $.cookie(this.cookieName);

    if ( cookieVal.indexOf(id) == -1 ) {
      cookieVal += id;
      cookieVal += ',';
      $.cookie(this.cookieName, cookieVal, { path: '/' });
      //this.changeHeartIconToActive();
      //this.loadProducts();
      $(element).removeClass('inspirationAddToFavorites').addClass('inspirationRemoveFromFavorites');
      dataLayer.push({event: 'addToFavorites', type: 'photo', label: $(element).data('motiveTitle')});
    }

    this.checkItemPresenceInFavorites();
  };

  InspirationFavorites.prototype.handleListenersForRemoveItemFromFavorites = function() {
    var self = this;

    $(document).on('click', '.inspirationRemoveFromFavorites', function(e) {
      e.preventDefault();
      var id = $(this).data('motiveId');
      self.removeFromFavorites(id, this);
    });

  };

  InspirationFavorites.prototype.removeFromFavorites = function(id, element) {

    var cookieVal = $.cookie(this.cookieName);

    if ( cookieVal.indexOf(id) == -1 ) {

    } else {
      cookieVal = cookieVal.slice(0,-1);
      if ( cookieVal.indexOf(',') > -1 ) {
        cookieVal = cookieVal.split(',').map(Number);
      } else {
        cookieVal = cookieVal.split().map(Number);
      }
      var removingProductIndex = cookieVal.indexOf(id);
      if (removingProductIndex > -1) {
        cookieVal.splice(removingProductIndex, 1);
      }

      $(element).removeClass('inspirationRemoveFromFavorites').addClass('inspirationAddToFavorites');

      cookieVal = cookieVal.toString();
      if (cookieVal.length > 0) {
        cookieVal += ',';
      }

      $.cookie(this.cookieName, cookieVal, { path: '/' });
    }

    this.checkItemPresenceInFavorites();
    if ( $('html').hasClass('inspirationFavoritesVisible') ) {
      if ( cookieVal == '' ) {
        this.showWholeContent();
      } else {
        this.showFavoritesOnly('switch');
      }
    }
    //this.loadProducts();
  };

  InspirationFavorites.prototype.handleHighSlide = function() {
    var self = this;
    var cookieVal = $.cookie(this.cookieName);
    var favoritesControlElement = $('.inspirationFavoritesControlButtonInCaption');
    var motiveId = $(favoritesControlElement).data('motiveId');
    if ( motiveId != 'undefined' ) {
      cookieVal = cookieVal.slice(0,-1);
      if ( cookieVal.indexOf(',') > -1 ) {
        cookieVal = cookieVal.split(',').map(Number);
      } else {
        cookieVal = cookieVal.split().map(Number);
      }
    }

    $(favoritesControlElement).each(function() {
      motiveId = $(this).data('motiveId');
      for (var i = 0; i < cookieVal.length; i++) {
        if (motiveId == cookieVal[i]) {
          $(this).removeClass('inspirationAddToFavorites').addClass('inspirationRemoveFromFavorites');
          $('em strong', this).text(self.messages[self.lang].removeFromFavorites);
        }
      }
    });
  };

  InspirationFavorites.prototype.handleListenersForShowFavoritesOnly = function() {
    var self = this;

    $(document).on('click', '.showFavoritesOnly', function(e) {
      e.preventDefault();
      self.showFavoritesOnly('switch');
    });

    if ( $('html').hasClass('inspirationFavoritesVisible') ) {
      $(document).on('betonSliderLoaded', function() {
        self.showFavoritesOnly('onLoad');
      });
    }
  };

  InspirationFavorites.prototype.handleListenersForShowWholeContent = function() {
    var self = this;

    $(document).on('click', '.showWholeContent', function(e) {
      e.preventDefault();
      self.showWholeContent();
    });
  };

  InspirationFavorites.prototype.handleListenersForPdfExport = function() {
    var self = this;

    $(document).on('click', '.exportToPdf', function(e) {
      e.preventDefault();
      self.composeAjaxWithFavoritesProducts();
    });
  };

  InspirationFavorites.prototype.composeAjaxWithFavoritesProducts = function() {
    var self = this;
    var cookieVal = $.cookie(this.cookieName);
    var arrToSendByAjax = [];
    var pdfDataSearch = '?';
    cookieVal = cookieVal.slice(0,-1);
    if ( cookieVal.indexOf(',') > -1 ) {
      cookieVal = cookieVal.split(',').map(Number);
    } else {
      cookieVal = cookieVal.split().map(Number);
    }

    for ( var i = 0; i < cookieVal.length; i++ ) {
      for ( var j = 0; j < window.projectConfig.favoritesRelationArr.length; j++ ) {
        if ( cookieVal[i] == window.projectConfig.favoritesRelationArr[j][0] ) {
          arrToSendByAjax.push(window.projectConfig.favoritesRelationArr[j][1]);
          //pdfDataSearch += 'id';
          //pdfDataSearch += '=';
          //pdfDataSearch += window.projectConfig.favoritesRelationArr[j][1];
          //pdfDataSearch += '&';
        }
      }
    }

    var uniqueArrItems = [];
    $.each(arrToSendByAjax, function(i, el){
      if($.inArray(el, uniqueArrItems) === -1) uniqueArrItems.push(el);
    });

    for ( var m = 0; m < uniqueArrItems.length; m++ ) {
      pdfDataSearch += 'id';
      pdfDataSearch += '=';
      pdfDataSearch += uniqueArrItems[m];
      pdfDataSearch += '&';
    }

    pdfDataSearch = pdfDataSearch.slice(0,-1);

    window.open(this.options.urlForPdfData + pdfDataSearch,'_blank');

  };

  InspirationFavorites.prototype.showFavoritesOnly = function(type) {
    var self = this;

    var favoritesList = '<ul class="list-unstyled row">';
    var cookieVal = $.cookie(this.cookieName);
    cookieVal = cookieVal.slice(0,-1);
    if ( cookieVal.indexOf(',') > -1 ) {
      cookieVal = cookieVal.split(',').map(Number);
    } else {
      cookieVal = cookieVal.split().map(Number);
    }
    $('.slider > ul > li').each(function() {
      var motiveId = $('.inspirationFavoritesControlButton', this).data('motiveId');
      for ( var i = 0; i < cookieVal.length; i++ ) {
        if ( motiveId == cookieVal[i] ) {
          favoritesList += '<li class="col-sm-6">';
          favoritesList += $(this).html();
          favoritesList += '</li>';
          favoritesList = favoritesList.replace(/946586343/g, '4569796464');
          hs.addSlideshow({ slideshowGroup: '4569796464'});
        }
      }
    });

    favoritesList += '</ul>';

    $('.inspirationFavoritesContent > .container').html(favoritesList);
    var inspirationFavoritesContent = $('.inspirationFavoritesContent');
    if ( type == 'switch' ) {
      $('.inspirationWholeContent').fadeOut(400, function() {
       $(inspirationFavoritesContent).fadeIn();

        self.setSameBoxHeight(inspirationFavoritesContent);
        $('img', self.element).unveil();
        $('html').addClass('inspirationFavoritesVisible');
       });
    } else if ( type == 'onLoad' ) {
      this.setSameBoxHeight(inspirationFavoritesContent);
      $('img', this.element).unveil();
    }
  };

  InspirationFavorites.prototype.showWholeContent = function() {
    var self = this;

    $('.inspirationFavoritesContent').fadeOut(400, function() {
      $('.inspirationWholeContent').fadeIn();
      $('html').removeClass('inspirationFavoritesVisible');
      self.setSameBoxHeight('.inspirationWholeContent');
      self.reloadContent();
      $('img', self.element).unveil();
    })
  };

  InspirationFavorites.prototype.reloadContent = function(element) {
    var self = this;
    var cookieVal = $.cookie(this.cookieName);
    var favoritesControlElement = $('.inspirationFavoritesControlButton');
    var motiveId = $(favoritesControlElement).data('motiveId');
    if ( motiveId != 'undefined' ) {
      cookieVal = cookieVal.slice(0,-1);
      if ( cookieVal.indexOf(',') > -1 ) {
        cookieVal = cookieVal.split(',').map(Number);
      } else {
        cookieVal = cookieVal.split().map(Number);
      }
    }

    $(favoritesControlElement).each(function() {
      $(this).removeClass('inspirationRemoveFromFavorites');
      $(this).addClass('inspirationAddToFavorites');
    });

    $(favoritesControlElement).each(function() {
      motiveId = $(this).data('motiveId');
      for ( var i = 0; i < cookieVal.length; i++ ) {
        if ( motiveId == cookieVal[i] ) {
          $(this).addClass('inspirationRemoveFromFavorites');
          $('em strong', this).text(self.messages[self.lang].removeFromFavorites);
        }
      }
    });
  };

  InspirationFavorites.prototype.setSameBoxHeight = function(element) {
    $(element).each(function() {
      var descriptionHeightArr = [];
      $('.description', this).each(function() {
        var descriptionHeight = $(this).height();
        descriptionHeightArr.push(descriptionHeight);
      });
      var max = Array.max(descriptionHeightArr);
      $('.description', this).css({'min-height' : max + 'px'});
    });
  };

  InspirationFavorites.prototype.checkItemPresenceInFavorites = function() {
    var self = this;
    var cookieVal = $.cookie(this.cookieName);

    if ( cookieVal == '' ) {
      $('.showFavoritesOnlyCnt').hide();
    } else {
      if (!($('html').hasClass('inspirationFavoritesVisible'))) {
        $('.showFavoritesOnlyCnt').show();
      }
    }

    var favoritesControlElement = $('.inspirationFavoritesControlButton');
    var motiveId = $(favoritesControlElement).data('motiveId');
    if ( motiveId != 'undefined' ) {
      cookieVal = cookieVal.slice(0,-1);
      if ( cookieVal.indexOf(',') > -1 ) {
        cookieVal = cookieVal.split(',').map(Number);
      } else {
        cookieVal = cookieVal.split().map(Number);
      }
    }

    $(favoritesControlElement).each(function() {
      motiveId = $(this).data('motiveId');
      for ( var i = 0; i < cookieVal.length; i++ ) {
        if ( motiveId == cookieVal[i] ) {
          $(this).addClass('inspirationRemoveFromFavorites');
          $('em strong', this).text(self.messages[self.lang].removeFromFavorites);
        }
      }
    });

    $(favoritesControlElement).each(function() {
      if (!($(this).hasClass('inspirationRemoveFromFavorites'))) {
        $(this).addClass('inspirationAddToFavorites');
        $('em strong', this).text(self.messages[self.lang].addToFavorites);
      }
    });
  };


  /**
   * decide, which methods will be "public"
   */
  var API = {
    //method: PluginSkeleton.prototype.method
    //loadMarkers: GoogleMap.prototype.loadMarkers
  };

  /**
   * plugin go live
   * @param value - first param - decides, which action shall be executed
   * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
   * 		if string && in API object - run method named as this value with all args[index > 0]
   * @return {*}
   */
  $.fn[PLUGIN_NAME] = function (value) {
    var args = arguments;

    return this.each(function () {
      var $this = $(this);

      // get plugin instance
      var plugin = $this.data('plugin_' + PLUGIN_NAME);

      // if there's not, create one
      if (!plugin) {
        plugin = new InspirationFavorites(this, value);
        $this.data('plugin_' + PLUGIN_NAME, plugin);
      }
      // if there is and first parameter is in predefined API methods, call it with rest of params
      else if (API[value]) {
        plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
      }
    });
  };

  /**
   * setDefaults with $.pluginSkeleton.setDefaults();
   */
  $[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
  $[PLUGIN_NAME].setDefaults = function(newOptions) {
    DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
  };
})( jQuery, window, document );



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.inspiration.favorites.js